import 'css-chunksrc/client/pages/projectPage/budgetPage/dateMonitoring/styles.scss';export default {
  "monitoring": "_monitoring_1s17r_1",
  "col": "_col_1s17r_14",
  "section": "_section_1s17r_23",
  "row": "_row_1s17r_30",
  "label": "_label_1s17r_38",
  "value": "_value_1s17r_45",
  "graph": "_graph_1s17r_51",
  "percentage": "_percentage_1s17r_58",
  "bar": "_bar_1s17r_68"
};